import { render } from "./LastSection.vue?vue&type=template&id=00812930&scoped=true"
import script from "./LastSection.vue?vue&type=script&lang=js"
export * from "./LastSection.vue?vue&type=script&lang=js"

import "./LastSection.vue?vue&type=style&index=0&id=00812930&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mkapp\\OneDrive\\Desktop\\Stage_Project\\Application_Front-end\\Moroccan-fork-front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00812930"]])

export default __exports__